export default "__VITE_ASSET__hpQeOuYz__"